export interface ISolarNoteRequest {
  igsCustomerNumber: string;
  userFilter: string;
  typeFilter: string;
  returnLimiter: number;
  hideSystemGenerated: boolean;
}

export class SolarNoteRequest implements ISolarNoteRequest {
  public igsCustomerNumber: string;
  public userFilter: string;
  public typeFilter: string;
  public returnLimiter: number;
  public hideSystemGenerated: boolean;
}
